"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vr = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
let Vr = class Vr extends vue_property_decorator_1.Vue {
    data() {
        return {
            style: 'border-left: 1px solid rgb(222, 226, 230); height: 1.2rem; margin-left: 0.4rem; padding-right: 1rem;'
        };
    }
};
exports.Vr = Vr;
exports.Vr = Vr = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div class="vr" :style=style></div>' })
], Vr);
//# sourceMappingURL=index.js.map